import { render, staticRenderFns } from "./StepHeaderMobile.vue?vue&type=template&id=df0dafc4&"
import script from "./StepHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./StepHeaderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports